export default __webpack_public_path__ + "static/media/message_in.fd21b5ef.mp3";